import { useQuery } from '@tanstack/react-query'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import {
  reservationRulesAndTermsResponseSchema,
  type ReservationRulesAndTermsResponse,
} from '../../../common/validations/reservationCalendarSchemas'

import { get } from 'api/apiClient'

export const reservationRulesAndTermsKey = (
  contractUuid: string,
  reservableCategory: string | null,
  language: string,
  realPropertyHierarchyId: number | null
) => {
  const baseKey = `${API_ENDPOINTS.RESERVATION_RULES_AND_TERMS.replace(':contractUuid', contractUuid)}`
  return [
    baseKey,
    reservableCategory,
    language,
    realPropertyHierarchyId,
  ] as const
}

const buildPath = (
  contractUuid: string,
  reservableCategory: string | null,
  language: string,
  realPropertyHierarchyId: number | null
) => {
  const basePath = API_ENDPOINTS.RESERVATION_RULES_AND_TERMS.replace(
    ':contractUuid',
    contractUuid
  )
  const searchParams = new URLSearchParams({ language })
  if (reservableCategory !== null) {
    searchParams.set('reservableCategory', reservableCategory)
  }
  if (realPropertyHierarchyId !== null) {
    searchParams.set('realPropertyHierarchyId', String(realPropertyHierarchyId))
  }
  return `${basePath}?${searchParams.toString()}`
}

export const useAPIGetReservationRulesAndTerms = (
  contractUuid: string,
  reservableCategory: string | null,
  language: string,
  realPropertyHierarchyId: number | null
) =>
  useQuery<ReservationRulesAndTermsResponse>({
    queryKey: reservationRulesAndTermsKey(
      contractUuid,
      reservableCategory,
      language,
      realPropertyHierarchyId
    ),
    queryFn: () =>
      get<ReservationRulesAndTermsResponse>(
        buildPath(
          contractUuid,
          reservableCategory,
          language,
          realPropertyHierarchyId
        ),
        reservationRulesAndTermsResponseSchema
      ),
    staleTime: 0,
    enabled: reservableCategory !== null && contractUuid !== '',
  })
